import AgreementsScreen from 'features/myVaro/screens/Legal/AgreementsScreen';
import React from 'react';

export default function Page() {
  return <AgreementsScreen />;
}
